import axios from '@pepper/utils/src/function/axiosInstance'

type Props = {
  ids: string[]
}

const deleteItems = async ({ ids }: Props) => {
  try {
    const res = await axios.delete('/items', {
      data: {
        ids,
      },
    })
    return res.data
  } catch (error) {
    return error
  }
}

export default deleteItems
